import axios from 'axios';
import { APIClient } from 'services/helpers/api_helper';
import * as url from 'services/helpers/url_helper';
import {
  BarcodeConfigApi,
  BarcodeConfigResponse,
  DocumentConfigApi,
  DocumentSaveResponse,
  InvoiceCodeConfigResponse,
  LogoUploadResponse,
  PointsConfigApi,
  PointsConfigResponse,
  PriceConfigApi,
  PriceConfigResponse,
  RoundingConfigApi,
  RoundingConfigResponse,
  SaleCodeConfigApi,
  ServiceChargeConfigApi,
  ServiceChargeConfigResponse,
  SettingsAccessResponse,
  StoreConfigResponse,
  WeightBarcodeConfigApi,
  WeightBarcodeConfigResponse,
} from 'types/settings/settingsApiTypes';

const api = new APIClient();

export const getSettings = async () => {
  try {
    const response: Promise<StoreConfigResponse> = await api.get(
      url.GET_SETTINGS
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getSettingsAccess = async () => {
  try {
    const response: Promise<SettingsAccessResponse> = await api.get(
      url.GET_SETTINGS_ACCESS
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

// อัปโหลดโลโก้ (multipart) → คืน temp file_name เอาไปใส่ใน document.logo_* ตอน save
export const uploadSettingsLogo = async (file: File) => {
  const formData = new FormData();
  formData.append('image', file);
  try {
    const response: LogoUploadResponse = await axios.post(
      url.POST_SETTINGS_LOGO,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const savePrice = async (payload: PriceConfigApi) => {
  try {
    const response: Promise<PriceConfigResponse> = await api.put(
      url.PUT_SETTINGS_PRICE,
      payload
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const saveBarcode = async (payload: BarcodeConfigApi) => {
  try {
    const response: Promise<BarcodeConfigResponse> = await api.put(
      url.PUT_SETTINGS_BARCODE,
      payload
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const saveWeightBarcode = async (payload: WeightBarcodeConfigApi) => {
  try {
    const response: Promise<WeightBarcodeConfigResponse> = await api.put(
      url.PUT_SETTINGS_WEIGHT_BARCODE,
      payload
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const saveDocument = async (payload: DocumentConfigApi) => {
  try {
    const response: Promise<DocumentSaveResponse> = await api.put(
      url.PUT_SETTINGS_DOCUMENT,
      payload
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const saveRounding = async (payload: RoundingConfigApi) => {
  try {
    const response: Promise<RoundingConfigResponse> = await api.put(
      url.PUT_SETTINGS_ROUNDING,
      payload
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const savePoints = async (payload: PointsConfigApi) => {
  try {
    const response: Promise<PointsConfigResponse> = await api.put(
      url.PUT_SETTINGS_POINTS,
      payload
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const saveServiceCharge = async (payload: ServiceChargeConfigApi) => {
  try {
    const response: Promise<ServiceChargeConfigResponse> = await api.put(
      url.PUT_SETTINGS_SERVICE_CHARGE,
      payload
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const saveInvoiceCode = async (payload: SaleCodeConfigApi) => {
  try {
    const response: Promise<InvoiceCodeConfigResponse> = await api.put(
      url.PUT_SETTINGS_INVOICE_CODE,
      payload
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
